// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-StudyList-StudyListItem-LibkeyLink-module__slot";
export { _1 as "slot" }
